import dayjs from 'dayjs'
import { isEmpty, startCase } from 'lodash'
import React, { useEffect, useState } from 'react'
import helper from '../../utils/helpers'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import OImage from 'components/reusable/OImage'
import { useLocation } from 'react-router-dom'

const CustomerDetail = ({ userDetails }) => {
  const location = useLocation()
  const { t } = useTranslation()
  const [userData, setUserData] = useState();

    useEffect(() => {
      setUserData(!isEmpty(location.state?.userDetails)
      ? location.state?.userDetails
      : userDetails)
    }, [location.state?.userDetails, userDetails])
    let latitude = userData?.location?.coordinates[0]
    let longitude = userData?.location?.coordinates[1]
    let url = 'https://www.google.com/maps?q='+`${latitude}`+`,${longitude}`
  return (
    
    <>
      <div className='relative  flex-auto'>
        <div className=' border-2 rounded-md p-5'>
          <div className='grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-4'>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_USER_ID')}:</strong>
              </div>
              {userData?.userUniqueId}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_USERNAME')}:</strong>
              </div>
              {userData?.username}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('USERS_FULL_NAME')}:</strong>
              </div>
              {startCase(userData?.firstName)+' '+startCase(userData?.lastName)}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Profile Image:</strong>
              </div>
              <OImage
                src={userData?.companyLogo}
                fallbackUrl='/images/userAvatar.png'
                className='w-24 h-24'
                alt=''
                style={{ borderRadius: '50%' }}
              />
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_MOBILE_NUMBER')}:</strong>
              </div>
              {'+'+userData?.country_code +' '+userData?.mobile || t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_EMAIL_ADDRESS')}:</strong>
              </div>
              {userData?.email || t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_ADDRESS')}:</strong>
              </div>
              {userData?.locations ? userData?.locations?.unionName +','+ userData?.locations?.upazilaName +','+ userData?.locations?.districtName : t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_CURRENT_LOCATION')}:</strong>
              </div>
              {userData?.location?.coordinates[0] && userData?.location?.coordinates[1] ? <a href={url} target='_blank'>Map Location</a> : t("O_N/A")}
            </div>
            
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_BIO')}:</strong>
              </div>
              <p className='break-all'>{userData?.bio || t("O_N/A")}</p>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_OCCUPATION')}:</strong>
              </div>
              {userData?.occupation?.length > 0 ? userData?.occupation?.map((item) => item.label ).join(', ') :  t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_INTERESTS')}:</strong>
              </div>
              {userData?.interest?.length > 0 ? userData?.interest?.map((item) => item.subcategory?.length > 0 && item?.subcategory.map((data) => data?.title) ).join(', ') :  t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_DOB')}:</strong>
              </div>
              {userData?.dob ? helper.dobFormat(userData?.dob) : t("O_N/A")}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Posts:</strong>
              </div>
              {userData?.posts?.length}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Sell Items:</strong>
              </div>
              {userData?.sellItems?.length}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Buy Items:</strong>
              </div>
              {userData?.buyItems?.length}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Sold Items:</strong>
              </div>
              {userData?.soldItems?.length}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Followings:</strong>
              </div>
              {userData?.followings?.length}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>Total Followers:</strong>
              </div>
              {userData?.followers?.length}
            </div>
            {/* <div className='mb-3'>
              <div className=''>
                <strong>{t('O_CREATED_AT')}:</strong>
              </div>
              {helper.dateFormat(item?.createdAt)}{' '}
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default CustomerDetail
